import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import GoogleLogInImg from '../../../../../assets/images/GoogleLogIn.png';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { loginDetails } from '../../../../../actions/auth';
import { getUserProfile } from '../../../../../actions/user';
import googleOAuth2 from '../../../../../actions/googleAuth';
import SPButton from '../../../../../components/SPButton';
import InputBox from '../../../../../components/InputBox';

import {
  FormContainer,
  FormDiv,
  QueryDiv,
  Query,
  MyForm
} from './StyledComponents';
import SPMessage from '../../../../../components/SPMessage';

const Form = ({
  loginStore,
  loginDetailsAction,
  previousPath,
  googleLoginStore,
  userStore

}) => {
  const [isFieldInvalid, setIsFieldInvalid] = useState(false);
  const [licenseInvalid, setLicenseInvalid] = useState(false);
  const [licenseInvalidMsg, setLicenseInvalidMsg] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorTitle, setErrorTitle] = useState('');

  const history = useHistory();

  useEffect(() => {
    if (loginStore.error?.code === 401) {
      setIsFieldInvalid(true);
    }
    if (loginStore.error?.code === 422) {
      setLicenseInvalid(true);
      setLicenseInvalidMsg(loginStore.error.message);
    }
  }, [loginStore.error]);

  useEffect(() => {
    if (googleLoginStore.error) {
      setIsError(true);
      setErrorTitle(googleLoginStore.error.data.message);
    }
  }, [googleLoginStore.error]);

  // useEffect(() => {
  //   if (userStore.userProfile && userStore.isProfileSuccess) {
  //     const profiledata = userStore.userProfile?.data?.profile[0];
  //     // if (profiledata.usr_google_auth_enable === 'Disable') {
  //     //   if (
  //     //     previousPath === null ||
  //     //     previousPath === undefined ||
  //     //     previousPath === '/login'
  //     //   ) {
  //     //     // history.push('/dashboard');
  //     //             console.log('deffer loginForm 1')

  //     //   } else {
  //     //     if (previousPath !== '/update-license') {
  //     //       history.push(previousPath);
  //     //       console.log('deffer loginForm 5')

  //     //     } else {
  //     //       history.push('/dashboard');
  //     //             console.log('deffer loginForm 2')

  //     //     }
  //     //   }
  //     // } else {
  //     //   history.push('/verify-code');
  //     // }
  //   }
  // }, [userStore.userProfile]);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Invalid Email Format').required('Required'),
      password: Yup
        .string()
        .required('Required')
        .min(8, 'Min 8 characters required')
    }),
    onSubmit: values => {
      const data = {
        email: values.email,
        password: values.password
      }
      loginDetailsAction(data, history, previousPath)
    }
  })

  const keyDown = e => {
    if (e.keyCode === 13) {
      formik.submitForm()
    }
  }

  const closeError = () => {
    setIsFieldInvalid(false);
    setLicenseInvalid(false);
    setLicenseInvalidMsg(false);
  };

  const handleChange = e => {
    if (isFieldInvalid && e.target.value) {
      setIsFieldInvalid(false);
    }
    if (licenseInvalid && e.target.value) {
      setLicenseInvalid(false);
      setLicenseInvalidMsg(false);
    }
    formik.handleChange(e);
  };

  return (
    <FormContainer>
      <FormDiv>
        {
          licenseInvalid && localStorage.getItem('organization') &&
          <SPMessage
            message={licenseInvalidMsg}
            type='info'
          />
        }
        {
          isFieldInvalid &&
          <SPMessage
            message='Invalid credentials'
            type='error'
            closable
            onClose={closeError}
          />
        }
        {
          isError &&
          <SPMessage
            message={errorTitle}
            type='error'
            closable
            onClose={closeError}
          />
        }
        <MyForm onSubmit={formik.handleSubmit}>
          <InputBox
            id='emailInput'
            label='Email'
            type='email'
            name='email'
            placeholder='example@email.com'
            onInputChange={handleChange}
            errorMessage={formik.errors.email}
            value={formik.values.email}
            onBlur={formik.handleBlur}
            touched={formik.touched.email}
            height={30}
          />
          <InputBox
            id='passwordInput'
            label='Password'
            type='password'
            onKeyHit={e => {
              keyDown(e);
            }}
            name='password'
            placeholder='Password'
            onInputChange={handleChange}
            errorMessage={formik.errors.password}
            value={formik.values.password}
            onBlur={formik.handleBlur}
            touched={formik.touched.password}
            height={30}
          />

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>

            <Link to='/forgot-password' style={{ textDecoration: 'none' }} replace>
              <QueryDiv>
                <Query>Forgot Password?</Query>
              </QueryDiv>
            </Link>

            {
              loginStore?.error?.code === 422 && localStorage.getItem('organization') &&
              <Link to='/update-license' replace>
                <QueryDiv>
                  <Query>Upload your license ?</Query>
                </QueryDiv>
              </Link>
            }

          </div>

          <SPButton
            title='Login'
            htmlType='submit'
            height={30}
          />
        </MyForm>
      </FormDiv>

      {/* <a href="https://staging.sirp.io/api/v1/google-login/auth?authclient=google" >
        <img src={GoogleLogInImg} alt="Google Auth" className="google-link" />
      </a> */}

    </FormContainer>
  );
};

const mapStateToProps = state => {
  return {
    loginStore: state.loginStore,
    googleLoginStore: state.googleLoginStore,
    userStore: state.userStore,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginDetailsAction: (...payload) => {
      return dispatch(loginDetails(...payload));
    },
    googleOAuth2Action: data => {
      return dispatch(googleOAuth2(data));
    },

    getUserProfileAction: data => {
      return dispatch(getUserProfile(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
